function YouShallNotPass() {
    return <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100vh' }}>
        <h2>You shall not pass!</h2>
        <p>Sorry, you don't have access to this page.</p>
        <img
            src="https://64.media.tumblr.com/09fe9fa3ee48703d9f4e1ffa7bdf2ac5/442b319e11a844f2-76/s400x600/c77faf974244d17101b3010cf1d74e72f7243871.gifv"
            alt="You shall not pass GIF"
            style={{ height: '300px', margin: '20px' }}
        />
    </div>;
}

export default YouShallNotPass;